// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3R7HB","tab":"Tabs_tab__lsPAC","tabActive":"Tabs_tabActive__1CuNx"};